module.exports = __webpack_public_path__ + "ch.f55af20b8350660cb6ac.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ch.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ch.svg
// module chunks = styles